'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconDownRightFromSquare, iconDownRightFromSquareTag } from '@ni/nimble-components/dist/esm/icons/down-right-from-square';
import { wrap } from '../../utilities/react-wrapper';

export type { IconDownRightFromSquare };
export { iconDownRightFromSquareTag };
export const NimbleIconDownRightFromSquare = wrap(IconDownRightFromSquare);